import React, { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, TextField } from '@mui/material';

export const REJECTION_REASON_MAX = 500;

interface RejectReasonDialogProps {
    open: boolean;
    submitting?: boolean;
    onCancel: () => void;
    /** Called with the trimmed reason; the Confirm button is disabled while it is blank. */
    onConfirm: (reason: string) => void;
}

const RejectReasonDialog: React.FC<RejectReasonDialogProps> = ({ open, submitting = false, onCancel, onConfirm }) => {
    const [reason, setReason] = useState('');

    useEffect(() => {
        if (open) setReason('');
    }, [open]);

    const trimmed = reason.trim();

    return (
        <Dialog data-help-page="store.reject.page" open={open} onClose={submitting ? undefined : onCancel} fullWidth maxWidth="sm">
            <DialogTitle>Reject this requisition?</DialogTitle>
            <DialogContent>
                <DialogContentText sx={{ mb: 2 }}>
                    The requester will see the reason and will need to raise a new requisition.
                </DialogContentText>
                <TextField
                    autoFocus
                    fullWidth
                    multiline
                    minRows={3}
                    data-help="store.reject.field.reason" label="Reason for rejection"
                    required
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                    inputProps={{ maxLength: REJECTION_REASON_MAX }}
                    helperText={`${reason.length}/${REJECTION_REASON_MAX}`}
                />
            </DialogContent>
            <DialogActions>
                <Button data-help="store.reject.cancel" onClick={onCancel} disabled={submitting}>Cancel</Button>
                <Button
                    data-help="store.reject.confirm" onClick={() => onConfirm(trimmed)}
                    color="error"
                    variant="contained"
                    disabled={submitting || trimmed === ''}
                >
                    Reject
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default RejectReasonDialog;
